export default "/images/7d3e0aecc4f549d22ffede73d4fee09a.avif";